import { Grid, MenuItem, Select, Typography } from '@mui/material';
import { jbColors } from 'theme/jbColors';

type DocumentTypeSelectProps = {
  formCode: string;
  formCodes: string[];
  setFormCode: (value: string) => void;
};

const DocumentTypeSelect = ({ formCode, formCodes, setFormCode }: DocumentTypeSelectProps) => {
  return (
    <Grid container sx={{ mt: 1, mb: 1 }} data-testid={'document-distribution-select'}>
      <Typography variant="body2" sx={{ color: jbColors.core.reflexBlue[100] }}>
        {`Select  document type${!formCode ? '*' : ''}:`}
      </Typography>
      <Select
        required
        value={formCode}
        onChange={(e) => {
          setFormCode(e.target.value);
        }}
        sx={{
          mt: 0.5,
          width: '100%',
          '& .MuiInputBase-root': {
            border: 'none',
            padding: 0,
            display: 'flex',
            color: 'black',
          },
          '& .MuiFormControl-root': {
            color: 'black',
          },
          '& .MuiInputBase-input': {
            border: 'none',
            padding: '8px',
            color: 'black',
          },
          '& .MuiOutlinedInput-input': {
            border: 'none',
            color: 'black',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',

            color: 'black',
          },
        }}
      >
        {formCodes?.length > 0 &&
          formCodes?.map((value: string) => {
            return (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            );
          })}
      </Select>
    </Grid>
  );
};

export default DocumentTypeSelect;
